import { createClient } from "@smfa/utils";
import { REQUEST_TIMEOUT } from "./home.actions";

const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;
const client = createClient({ baseUrl, isAdminSite: true });

export const deleteAdminUpload = ({ resource, id, field }, requestConfig = {}) =>
  client.delete("/file", {
    data: { resource, id, field },
    timeout: REQUEST_TIMEOUT,
    ...(requestConfig.signal ? { signal: requestConfig.signal } : {}),
  });
